<template>
  <div class="panel-group" id="accordion" role="tablist">
    <div class="panel-action" :class="{panelPadding: modeVue}">
      <b-button-group v-if="!hideGenerate">
        <b-button
          v-if="!this.generating()"
          @click.prevent="generateFicheEspace()"
          :disabled="!!!this.selectedCount"
          class="txt-btn"
          variant="outline-primary"
        >
          <font-awesome-icon :icon="['fas', 'save']" /> Générer fiche
        </b-button>
        <b-button v-else class="txt-btn" variant="primary">
          <b-spinner small type="grow"></b-spinner> En attente...
        </b-button>
      </b-button-group>
    </div>

    <vue-custom-scrollbar class="scroll-area" :settings="settings">
      <div
        v-for="tdata in tableauData"
        :key="tdata.id"
        class="panel panel-default"
      >
        <div class="panel-heading" role="tab">
          <h4 class="panel-title">
            <a block role="button" v-b-toggle="'collapse-' + tdata.id">
              {{ tdata.nom }}
            </a>
          </h4>
        </div>
        <b-collapse :id="`collapse-${tdata.id}`" role="tabpanel">
          <div class="panel-collapse">
            <div class="panel-body">
              <b-list-group>
                <b-form-group>
                  <template v-if="ficheData[tdata.id].length !== 0">
                    <b-list-group-item v-if="!modeVue">
                      <b-form-checkbox
                        v-model="allSelected[tdata.id]"
                        @change="toggleAll(tdata.id)"
                      >
                        {{
                          allSelected[tdata.id]
                            ? "Tout déselectionner"
                            : "Tout sélectionner"
                        }}
                      </b-form-checkbox>
                    </b-list-group-item>
                    <b-form-checkbox-group
                      :id="'checkbox-group-' + tdata.id"
                      v-model="selected[tdata.id]"
                      name="to-generate"
                    >
                      <template v-for="(data, index) in ficheData[tdata.id]">
                        <b-list-group-item v-if="!data.generated" :key="index" :style="{paddingLeft: applyPadding(data.level)}">
                          <b-form-checkbox
                                  v-if="!data.isEnsemble"
                                  @change="pushSelected(tdata.id, data.ligne, $event)"
                                  :value="{
                                  ficheId: data.ficheId,
                                  onglet: data.onglet,
                                  ligne: data.ligne,
                                  title: data.denomination,
                                  isEnsemble: data.isEnsemble,
                                  data: { elements: [...defaultFicheLayout] }
                                }"
                          >
                            {{ data.denomination }}
                          </b-form-checkbox>
                          <span v-else>
                            <b-form-checkbox
                                    style="display: none"
                                    @change="pushSelected(tdata.id, data.ligne, $event)"
                                    :value="{
                                  onglet: data.onglet,
                                    ficheId: data.ficheId,
                                  ligne: data.ligne,
                                  title: data.denomination,
                                  isEnsemble: data.isEnsemble,
                                  data: { elements: [...defaultFicheLayout] }
                                }"
                              >
                               </b-form-checkbox>
                            {{ data.denomination }}
                          </span>
                        </b-list-group-item>
                        <b-list-group-item
                                :style="{paddingLeft: applyPadding(data.level)}"
                          style="cursor: pointer;"
                          v-else
                          :key="index"

                          active
                        >
                          <div class="d-flex row-espace">
                            <div class="flex-grow-1">
                              <b-form-checkbox
                                v-if="!data.isEnsemble"
                                @change="pushSelected(tdata.id, data.ligne, $event)"
                                :value="{
                                    ficheId: data.ficheId,
                                  onglet: data.onglet,
                                  ligne: data.ligne,
                                  title: data.denomination,
                                  isEnsemble: data.isEnsemble,
                                  data: { elements: [...defaultFicheLayout] }
                                }"
                              >
                              </b-form-checkbox>

                              <span v-else>
                              <b-form-checkbox
                                      style="display:none"
                                      @change="pushSelected(tdata.id, data.ligne, $event)"
                                      :value="{
                                    ficheId: data.ficheId,
                                  onglet: data.onglet,
                                  ligne: data.ligne,
                                  title: data.denomination,
                                  isEnsemble: data.isEnsemble,
                                  data: { elements: [...defaultFicheLayout] }
                                }"
                              >
                              </b-form-checkbox>
                              </span>

                              <span @click.stop="showFiche(data.ficheId, data.ligne, data.templateId, tdata.id)">
                                  {{ data.denomination }}
                              </span>
                            </div>
                            <div class="action pt-1" v-if="!modeVue">
                              <b-button
                                @click.prevent.stop="showDeleteConfirmation(data)"
                                v-b-popover.hover.bottom="
                                  `Supprimer la fiche correspondante`
                                "
                                class="delete"
                                size="sm"
                                variant="outline-secondary"
                              >
                                <font-awesome-icon :icon="['fas', 'trash-alt']" />
                              </b-button>
                            </div>
                          </div>
                        </b-list-group-item>
                      </template>
                    </b-form-checkbox-group>
                  </template>
                  <template v-else>
                    <b-list-group-item>
                      Aucun espace trouvé, veuillez remplir votre tableau de
                      surface
                    </b-list-group-item>
                  </template>
                </b-form-group>
              </b-list-group>
            </div>
          </div>
        </b-collapse>
      </div>
    </vue-custom-scrollbar>
  </div>
</template>

<script>
import loading from '../loading'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { mapActions, mapGetters } from 'vuex'
import { defaultFicheLayout, defaultTitleStyle } from '../../config/constanteUse'
import {eventBus} from '../../main'
import axios from 'axios'
import { ENTRYPOINT } from '../../config/entrypoint'
import { SET_SELECTED_FICHES } from "../../store/modules/ficheEspace/mutation_types";
export default {
  components: {
    loading,
    vueCustomScrollbar
  },
  props: {
    tableauData: null,
    modeVue: false,
    hideGenerate: true
  },
  data () {
    return {
      ficheData: {},
      reducedTdata: null,
      selected: {},
      singleSelected: [],
      allSelected: {},
      selectedCount: 0,
      defaultFicheLayout,
      defaultTitleStyle,
      settings: {
        maxScrollbarLength: 60
      }
    }
  },
  watch: {
    selected: {
      handler (val) {
        let count = 0
        this.tableauData.forEach(el => {
          count += val[el.id].length
          this.allSelected[el.id] = val[el.id].length === this.ficheData[el.id].length
        })
        this.selectedCount = count

        // eventBus.$on('emptySelected', (message) => {
        //   this.selected = {}
        // })
      },
      deep: true
    },
    tableauData (newValue, oldValue) {
      this.reducedTdata = newValue.reduce((acc, curr) => {
        acc[curr.id] = curr
        return acc
      }, {})
      Object.keys(this.reducedTdata).forEach(key => {
        this.ficheData[key] = this.filteredSurface(this.reducedTdata[key], key)
        this.$set(this.selected, key, [])
        this.$set(this.allSelected, key, false)
      })
    }
  },
  created () {
    this.reducedTdata = this.tableauData.reduce((acc, curr) => {
      acc[curr.id] = curr
      return acc
    }, {})

    Object.keys(this.reducedTdata).forEach(key => {
      this.ficheData[key] = this.filteredSurface(this.reducedTdata[key], key)
      this.$set(this.selected, key, [])
      this.$set(this.allSelected, key, false)
    })
  },
  methods: {
    ...mapActions(['setMessage', 'setCurrentLigne', 'setEntityId', 'generateFiche', 'deleteFiche', 'setCurrentFiche', 'deleteFicheEspaces', 'setGenerating', 'setTableauTemplateId']),
    ...mapGetters(['generating', 'tableauTemplateId']),
    filteredSurface (unfilteredSurfaces, onglet) {
      const res = []
      if (!unfilteredSurfaces.columns) {
        return res
      }
      const code = unfilteredSurfaces.columns.findIndex(col => col.key === 'H0')
      const denomination = unfilteredSurfaces.columns.findIndex(col => col.key === 'H1')

      var iteration = 0
      console.log(unfilteredSurfaces)
      unfilteredSurfaces.data.forEach((el, index) => {
        if (el !== null) {
          const isEspace = !unfilteredSurfaces.rows[index] || unfilteredSurfaces.rows[index].type !== 'ensemble'
          var isEnsemble = false
          var level = 0

          if (unfilteredSurfaces.rows[index]) {
            isEnsemble = unfilteredSurfaces.rows[index].type === 'ensemble'
            level = unfilteredSurfaces.rows[index].level
          }

          var elCode = el !== null && el[code] !== '' ? el[code] : ''

          if ((index !== 0 && Array.isArray(el) && el.length && el[denomination] && elCode !== '') || isEnsemble) {
            var ficheId = (!!unfilteredSurfaces.rows && !!unfilteredSurfaces.rows[index] && !!unfilteredSurfaces.rows[index].fiche) ? unfilteredSurfaces.rows[index].fiche : null

            if (typeof unfilteredSurfaces.ficheLines[ficheId] !== 'undefined' && isEnsemble) {
              var ligne = parseInt(unfilteredSurfaces.ficheLines[ficheId]) + 1
            } else {
              var ligne = index
              // console.log(ligne + ' : ' + el[denomination])
            }

            res.push({
              onglet,
              level: level,
              ligne: ligne,
              isEnsemble: isEnsemble,
              code: elCode,
              data: unfilteredSurfaces.fichesEspaces[index],
              denomination: el[denomination],
              generated: !!unfilteredSurfaces.rows && !!unfilteredSurfaces.rows[index] && !!unfilteredSurfaces.rows[index].fiche,
              ficheId: (!!unfilteredSurfaces.rows && !!unfilteredSurfaces.rows[ligne] && !!unfilteredSurfaces.rows[ligne].fiche) ? unfilteredSurfaces.rows[ligne].fiche : null,
              templateId: unfilteredSurfaces.templateId
            })
          }
        }
      })
      return res
    },
    pushSelected (onglet, ligne) {
      this.$store.commit(SET_SELECTED_FICHES, this.selected);
      eventBus.$emit('getSelected', this.selected)
    },
    toggleAll (onglet) {
      const filteredFicheData = this.ficheData[onglet]

      this.selected[onglet] = !this.allSelected[onglet] ? filteredFicheData.map(el => ({
        onglet: el.onglet,
        ligne: el.ligne,
        title: el.denomination,
        isEnsemble: el.isEnsemble,
        ficheId: el.ficheId,
        data: { elements: [...defaultFicheLayout] } })) : []

      this.$store.commit(SET_SELECTED_FICHES, this.selected);
      eventBus.$emit('getSelected', this.selected)
    },
    async generateFicheEspace () {
      this.setGenerating(true)
      const data = Object.keys(this.selected).map(key => this.selected[key]).flat()

      const toUpdate = {}
      data.forEach(el => {
        toUpdate[el.onglet] = this.reducedTdata[el.onglet]
      })

      const res = await this.generateFiche({ data, toUpdate })
      this.setGenerating(false)
      this.setMessage(res)
    },
    showFiche (ficheId, ligne, templateId = null, onglet) {
      window.ligne = ligne
      window.ficheData = this.ficheData[onglet]
      window.localStorage.setItem('ficheData', JSON.stringify(window.ficheData))
      this.setCurrentFiche(ficheId)
      this.setCurrentLigne(ligne)
      this.setEntityId(ficheId)
      this.setTableauTemplateId(templateId)
      this.$store.commit(SET_SELECTED_FICHES, this.selected);
      eventBus.$emit('getSelected', this.selected)
    },
    showDeleteConfirmation (fiche) {
      this.$bvModal.msgBoxConfirm(`Voulez-vous vraiment supprimer la fiche "${fiche.denomination}" ?`, {
        modalClass: 'base-modal',
        title: 'Suppression de fiche',
        buttonSize: 'sm',
        headerClass: 'bg-danger',
        okVariant: 'outline-danger',
        okTitle: 'OUI',
        cancelVariant: 'outline-primary',
        cancelTitle: 'NON',
        footerClass: 'p-2',
        hideHeaderClose: true
      })
        .then(async value => {
          if (value) {
            this.setGenerating(true)
            const toUpdate = {}
            toUpdate[fiche.onglet] = this.reducedTdata[fiche.onglet]
            const res = await this.deleteFiche({ fiche, toUpdate })
            this.setGenerating(false)
            this.setMessage(res)
          }
        })
    },
    applyPadding (level) {
      if (level === 0) {
        return level * 2 + 5 + 'px'
      }

      return level * 20 + 'px'
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-control-inline {
    margin-right:0;
    vertical-align: top;
}
.custom-control-label::before {
    position: absolute;
    top: 0.15rem;
    left: -1.5rem;
    display: block;
    width: 15px;
    height: 15px;
    pointer-events: none;
    content: "";
    background-color: #fff;
    border: #adb5bd solid 1px;
}

#accordion {
  font-family: "Noto Sans";
  user-select: none;
  button[disabled="disabled"] {
    cursor: not-allowed;
  }
  a:hover,
  a:focus {
    text-decoration: none;
    outline: none;
  }
  .panel {
    border: none;
    box-shadow: none;
    border-radius: 0;
    margin-bottom: 15px;
  }
  .panel-action {
    margin-bottom: 40px;
    margin-top: 30px;
    button {
      border-radius: 0;
      height: 25px;
      line-height: 25px;
    }
    &.panelPadding {
      padding-top: 25px;
    }
  }
  .panel-heading {
    padding: 0;
    border-radius: 0;
    border: none;
  }
  .panel-title {
    margin-bottom: -1px;
    text-align: center;
  }
  .panel-title a {
    border-radius: 3px;
    background-color: #2b3085;
    color: #fff;
    display: block;
    font-size: 14px;
    line-height: 28px;
    height: 28px;
  }
  .panel-title a.collapsed {
  }
  .panel-title a.collapsed:hover {
    color: #fff;
  }
  .panel-title a:before {
  }
  .panel-title a.collapsed:hover:before {
  }
  .panel-title a:after {
    position: absolute;
    left: 10px;
    top: 50%;
    color: #fff;
    transform: translateY(-50%);
  }
  .panel-title a.collapsed:after {
    color: #9f9f9f;
  }
  .panel-title a.collapsed:hover:after {
    color: #fff;
  }
  .panel-body {
    font-size: 14px;
    color: #2b3085;
    line-height: 25px;
    padding: 0;
    position: relative;
    border: none;
    transition: all 0.5s ease 0s;
    .list-group {
      .form-group {
        margin-bottom: 10px;
      }
    }
    .list-group-item {
      padding-top: 0px;
      padding-bottom: 0px;
      font-size: 12px;
      font-weight: 600;
      border: 1px solid #2b3085;
      border-top: none;
      border-radius: 0;
      padding-left: 5px;
      padding-right: 5px;
      &.active {
        background-color: #9395c1;
        border: none;
        border-left: 1px solid #2b3085;
        border-right: 1px solid #2b3085;
      }
      &:last-child {
        border-radius: 0 0 3px 3px;
      }
      .custom-control-label {
        padding-top: 4px;
      }
    }
  }
  .panel-body p {
    margin-bottom: 0;
  }
  .action {
    button {
      border: none;
      background-color: transparent !important;
      color: #fff !important;
    }
  }
  .row-espace {
    align-items: center;
    /*padding-left: 25px;*/
  }
  .scroll-area {
    height: calc(100vh - 200px);
    padding-right: 15px;
  }
  .ps__thumb-x, .ps__thumb-y {
    background-color: #2b3085 !important;
    width: 6px !important;
    right: 0;
    &:hover {
      background-color: #2b3085;
      width: 6px;
    }
  }
  .ps__rail-y {
    display: block;
    width: 8px;
    border: 1px solid #2b3085;
    border-radius: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/listeEspace.vue